import { add } from 'date-fns/add';
import type { Duration } from 'date-fns';
import { fromZonedTime } from 'date-fns-tz';

export function generateCookieExpire(expires: number, unit: keyof Duration = 'days') {
  return new Date(add(fromZonedTime(new Date(), 'GMT'), { [unit]: expires }));
}
